import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchProject = () => api.get("/project").then((r) => r.data);
export const fetchThemes = () => api.get("/themes").then((r) => r.data);
export const fetchTheme = (slug) => api.get(`/themes/${slug}`).then((r) => r.data);
export const fetchContributions = (params = {}) =>
    api.get("/contributions", { params }).then((r) => r.data);
export const fetchSchools = () => api.get("/schools").then((r) => r.data);
export const fetchStats = () => api.get("/stats").then((r) => r.data);
